import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Ribbon } from "../components/Ribbon";
import { Services } from "../components/Services";
import { WrapColors } from "../components/WrapColors";
import { StyleAdvisor } from "../components/StyleAdvisor";
import { PPFSection } from "../components/PPFSection";
import { Gallery } from "../components/Gallery";
import { HeadlightFilms } from "../components/HeadlightFilms";
import { Dechromage } from "../components/Dechromage";
import { WindowTint } from "../components/WindowTint";
import { Polish } from "../components/Polish";
import { WhyUs } from "../components/WhyUs";
import { Pricing } from "../components/Pricing";
import { Payment } from "../components/Payment";
import { QuoteForm } from "../components/QuoteForm";
import { Footer } from "../components/Footer";
import { smoothScrollTo } from "../lib/scroll";

const scrollTo = (sel) => smoothScrollTo(sel, 80);

export default function Home() {
  const scrollToDevis = () => scrollTo("#devis");
  return (
    <div data-testid="home-page">
      <Navbar />
      <Hero onQuote={scrollToDevis} />
      <Ribbon />
      <Services />
      <WrapColors onQuote={scrollToDevis} />
      <StyleAdvisor onQuote={scrollToDevis} />
      <PPFSection onQuote={scrollToDevis} />
      <Gallery />
      <HeadlightFilms onQuote={scrollToDevis} />
      <Dechromage onQuote={scrollToDevis} />
      <WindowTint onQuote={scrollToDevis} />
      <Polish onQuote={scrollToDevis} />
      <WhyUs />
      <Pricing onQuote={scrollToDevis} />
      <Payment onQuote={scrollToDevis} />
      <QuoteForm />
      <Footer />
    </div>
  );
}
